module.exports = __webpack_public_path__ + "img/avatar-icon-images.fd685134.png";